import axios from 'axios'
import util from './util'
import i18n from '../lang/index'
import {Message, MessageBox} from 'element-ui'

axios.defaults.crossDomain = true
axios.defaults.withCredentials = true

// 请求超时时间
axios.defaults.timeout = 0 * 15e3 // 单位毫秒，e3为10^3
// axios.defaults.baseURL = process.env.YISU_API_URL

// post请求头
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Content-Language'] = 'zh';
window.TokenFlag = true;

// 请求拦截器
axios.interceptors.request.use(
  config => {
    let locale = util.getCookie('locale');
    if(locale !== null){
      config.headers.common['lang'] = locale
    }
    return config
  },
  error => {
    // console.log('请求', error)
    return Promise.error(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    switch (response.data.code) {
      case 401:
      case 422:
        if(!window.TokenFlag) return false;
        window.TokenFlag = false;
        let login_state = util.getCookie('agent_auto_login');
        if (login_state) {
          axios.post(util.getApiUrl() + '/home/user/autoLogin', {
            token: login_state
          })
            .then(function (response) {
              if (response.data.code == 0) {
                MessageBox.alert(i18n.t('common.message.sessionExpired'), i18n.t('common.message.warning'), {
                  confirmButtonText: i18n.t('common.message.ok'),
                  type: 'error',
                  showClose: false,
                  closeOnClickModal: false
                }).then(() => {
                  window.location.reload()
                }).catch(() => {

                })
                return false;
              }
            }).catch(function (error) {
                this.$util.handleErr(error);
            })
        } else {
          MessageBox.alert(i18n.t('common.message.requestExpired'), i18n.t('common.message.warning'), {
            confirmButtonText: i18n.t('common.message.ok'),
            type: 'error',
            showClose: false,
            closeOnClickModal: false
          }).then(() => {
            window.location.href =util.getLoginUrl()+'?callback='+encodeURIComponent(window.location.href);
          }).catch(() => {

          })
        }
        return false;
        break
      // 数据库通用错误
      case 15001:
        //实例不存在
        window.TokenFlag = true;
        Message.error(response.data.message);
        setTimeout(function () {
          window.location.href = "/database/rds";
        }, 2000);
        break ;
      case -2:
      case 15002:
        window.TokenFlag = true;
        Message.error(response.data.message);
        return Promise.resolve(response)
        break ;
      default:
        window.TokenFlag = true;
        return Promise.resolve(response)
    }
  },
  error => {
    if (error.response && error.response.data && error.response.data.message) {
      error.message = error.response.data.message
    }
    return Promise.reject(error)
  }
)

function get (urls, params) {
  let baseURL = util.getApiUrl()
  let url = baseURL + urls
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
};

/**
 * post方法，对应post请求
 * @param {String} urls [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 **/
function post (urls, params) {
  let baseURL = util.getApiUrl()
  let url = baseURL + urls
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
};

export default {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/utils/http.js